export default __webpack_public_path__ + "static/media/PedroBatista.08dad67e.png";